"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const constants_1 = require("../constants");
// temporary implementation. Wait till proper theming is implemented
const isLightTheme = (themeName) => {
    if (!window.CUSTOMER_NAME) {
        window.CUSTOMER_NAME = '';
    }
    return ['default', 'light', `${CUSTOMER_NAME}-default`, `${CUSTOMER_NAME}-alt`].includes(themeName);
};
const useWatermark = (provider, forcedTheme, customLogo) => {
    const theme = (0, styled_components_1.useTheme)();
    const themeAccent = forcedTheme || (isLightTheme(theme.name) ? 'light' : 'dark');
    const watermark = (0, react_1.useMemo)(() => {
        if (customLogo) {
            return customLogo;
        }
        // provider can be set to 'custom' for readability reason only
        // the only way to get custom logo is to pass it as a prop (customLogo)
        if (!provider || !themeAccent || provider === 'custom') {
            return () => null;
        }
        const mark = constants_1.watermarksMap[provider.toLowerCase()] || {};
        return mark[themeAccent];
    }, [provider, themeAccent, customLogo]);
    return {
        Watermark: watermark,
        themeAccent
    };
};
exports.default = useWatermark;
